// extracted by mini-css-extract-plugin
export var addButton = "_b0-0";
export var border = "_b0-8";
export var check = "_b0-h";
export var danger = "_b0-6";
export var dropdownContainer = "_b0-1";
export var editModalBody = "_b0-j";
export var footerContainer = "_b0-i";
export var fullWidth = "_b0-a";
export var hide = "_b0-9";
export var icon = "_b0-3";
export var input = "_b0-7";
export var inputFlex = "_b0-b";
export var inputWrapper = "_b0-c";
export var manualFocus = "_b0-5";
export var optionButton = "_b0-4";
export var pillWrapper = "_b0-e";
export var pointer = "_b0-2";
export var showOverflow = "_b0-f";
export var tagsFlex = "_b0-d";
export var xButton = "_b0-g";